module.exports = __webpack_public_path__ + "static/img/科普体验中心.c621d19d.png";